import axios from "axios";
import { _authHeader } from "./auth._header";
import helpers from "@/helpers/helper";

const API_URL = helpers.API_ENDPOINT;

class ActivityService {
    getCategory(data) {
        var page = data ? data.page : 1;
        if (data.select) {
            return axios.get(API_URL + "blog/category" + "?page=" + page + '&size=' + data.size, { headers: _authHeader(), }).then((response) => {
                return response.data;
            });
        } else {
            return axios.get(API_URL + "blog/category", { headers: _authHeader(), }).then((response) => {
                return response.data;
            });
        }
    }
    getBlog(data) {
        var page = data ? data.page : 1;
        return axios.get(API_URL + "blog/posts" + "?page=" + page, { headers: _authHeader(), }).then((response) => {
            return response.data;
        });
    }
}

export default new ActivityService();